<template>
<div v-loading="entireLoading">
  <!-- Header -->
  <el-row v-if="!isPopupView" class="btn-top-area">
    <el-col :span="12">
      <el-button size="small" @click="showTroubleTicketList">목록보기</el-button>
    </el-col>
    <el-col :span="12">
      <div class="align-right">
        <el-button icon="fas fa-caret-left" size="small" v-show="showPrevBtn" @click="clickPrevButton()"></el-button>
        <el-button icon="fas fa-caret-right" size="small" v-show="showNextBtn" @click="clickNextButton()"></el-button>
      </div>
    </el-col>
  </el-row>
  <el-row class="mr-b25">
    <el-col :span="24">
      <table class="list-another02">
        <tfoot>
          <tr>
            <th><span class="txt-space">작성자</span>{{troubleTicketInfo.lastEditerId}}</th>
            <td>
              <el-button style="padding-top:1px" size="small" type="secondary" v-show="!isCompletedTicket && !isReadOnlyTicket" @click="showTroubleTicketCompleteReportPopup">처리완료</el-button>
              <el-button style="padding-top:1px" size="small" type="secondary" v-show="isCompletedTicket  && !isReadOnlyTicket" @click="addKedbByTicket">+ KEDB 등록</el-button>
            </td>
          </tr>
        </tfoot>
        <tr>
          <th>
            <span class="de-list">[#{{troubleTicketInfo.troubleTicketGroupId}}]  {{troubleTicketInfo.subject}}  -  <span class="high">{{troubleTicketInfo.troubleStatusName}}</span></span>
          </th>
          <td>
            <span class="txt-space">{{getDateFormatter(null, null, troubleTicketInfo.lastEditDatetime)}}</span>
          </td>
        </tr>
      </table>
    </el-col>
  </el-row>
  <!-- 장애 티켓 정보 -->
  <div class="list-dot-tit mr-b25">
    <strong class="list-tit"><span>장애티켓 정보</span></strong>
    <el-row :gutter="20">
      <el-col :span="12" class="list form-list">
        <el-form ref="form" label-position="left">
          <el-form-item label="티켓번호" label-width="100px">{{troubleTicketInfo.troubleTicketGroupId}}</el-form-item>
          <el-form-item label="발행자" label-width="100px">{{troubleTicketInfo.writerId}}</el-form-item>
          <el-form-item label="발행일시" label-width="100px">{{getDateFormatter(null, null, troubleTicketInfo.writeDatetime)}}</el-form-item>
        </el-form>
      </el-col>
      <el-col class="list form-list" :span="12">
        <el-form ref="form" size="mini" label-position="left">
          <el-form-item label="처리구분" label-width="120px">{{troubleTicketInfo.troubleStatusName}}</el-form-item>
          <el-form-item label="긴급도" label-width="120px">{{troubleTicketInfo.troubleUrgencyName}}</el-form-item>
          <el-form-item label="영향도" label-width="120px">{{troubleTicketInfo.troubleImpactName}}</el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
  <!-- 대상 이벤트 정보 -->
  <div class="list-dot-tit mr-b30">
    <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
      <strong class="list-tit" style="line-height:28px;padding-bottom:0px;"><span>대상 이벤트 정보</span></strong>
      <w-recommend-handling-trouble-button :event-hist-seq-numbers="eventHistSeqNumbers"></w-recommend-handling-trouble-button>
    </el-row>
    <el-table-wrapper ref="eventTable" :column-default="columnDefault" :data="eventList" :columns="targetEventColumn" @selection-change="onEventSelectionChange" :pagination="false" highlight-current-row>
      <template slot-scope="scope" slot="eventlevel-slot">
          <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
        </template>
      <template slot-scope="scope" slot="event-count-slot">
        <span class="link" @click="showtTargetEventHistPopup(scope.row)">{{ scope.row.eventCount }}</span>
      </template>
      <template slot-scope="scope" slot="event-message-slot">
        <div v-if="scope.row.dynamicThresholdFlag === 'Y'" class="round-box-info-text red">
          동적
        </div>
        {{scope.row.eventMessage}}
      </template>
      <template #obj-name-slot="scope">
        <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
        <span v-else>-</span>
      </template>
    </el-table-wrapper>
  </div>
  <!-- 처리 결과 보고서 -->
  <div class="list-dot-tit mr-b25" v-show="isCompletedTicket">
    <strong class="list-tit"><span>처리 결과 보고서</span></strong>
    <el-row>
      <el-col :span="24">
        <div class="list-type-number">
          <ol>
            <li><strong>1. <span>장애 증상</span> : </strong> <span>{{troubleTicketInfo.troubleSymptom}}</span></li>
            <li><strong>2. <span>장애 원인</span> : </strong> <span>{{troubleTicketInfo.troubleReason}}</span></li>
            <li><strong>3. <span>처리 내용</span> : </strong> <span>{{troubleTicketInfo.troubleTreatment}}</span></li>
          </ol>
        </div>
      </el-col>
    </el-row>
  </div>
  <!-- 의견 등록 -->
  <div v-show="!isCompletedTicket && !isReadOnlyTicket" class="list-dot-tit mr-b25">
    <el-row class="title-bar" style="margin:0px;" type="flex" justify="space-between">
      <strong class="list-tit" style="line-height:28px;padding-bottom:0px;"><span>처리 이력 등록</span></strong>
      <el-upload :before-upload="(file) => file" action="" :file-list="fileList" :auto-upload="false" :show-file-list="false" accept :on-change="changeUploadFile" ref="fileUpload">
        <span style="color: black; padding-right:10px">{{fileList.name}}</span>
        <el-button type="primary" size="mini">파일업로드</el-button>
        <el-button size="mini" :disabled="!isAbleApplyTicketHist" @click.stop="addProcessHist">등록</el-button>
      </el-upload>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form>
          <el-form-item>
            <el-input type="textarea" v-model="eventTicketStatusComment" :rows="5" class="ticket-input-class"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table-wrapper v-show="fileList !== null && fileList !== undefined && fileList.length > 0" :data="fileList" :columns="attachFileColumns" :show-custom-header="false" :show-search-tool="false" style="width:100%;" :pagination="false" :column-default="columnDefault">
      <template #delete-slot="scope">
         <i class="far fa-times c-pointer" @click="deleteAttachFileInfo(scope.row)"></i>
       </template>
    </el-table-wrapper>
  </div>
  <!-- 처리 이력 -->
  <div class="list-dot-tit mr-b25">
    <strong class="list-tit"><span>처리 이력</span></strong>
    <el-table v-loading="histLoading" :data="troubleShootingHist" :columns="processHistColumn" :pagination="false" style="width:100%; margin-bottom: 10px;" highlight-current-row>
      <el-table-column type="expand">
        <template slot-scope="scope">
            <div class="list form-list">
              <el-form ref="form" label-position="right">
                <el-form-item label="처리자" label-width="100px">{{scope.row.registerId}}</el-form-item>
                <el-form-item label="내용" label-width="100px">{{getEmptyText(null, null, scope.row.comment)}}</el-form-item>
                <el-form-item v-show="scope.row.fileInfo" label="첨부파일" label-width="100px">
                  <span v-for="item in scope.row.fileInfo" :key="item.attachFilename">
                    <i class="far fa-file-download mr-r4"></i>
                    <span class="link c-pointer mr-r10" @click="downloadAttachFile(item)">{{item.attachFilename}}.{{item.attachFiletype}}</span>
                  </span>
                </el-form-item>
              </el-form>
            </div>
          </template>
      </el-table-column>
      <el-table-column label="작성일시" prop="registDatetime" width="155px" :formatter="getDateFormatter">
      </el-table-column>
      <el-table-column label="작성자" prop="registerId" width="135px"></el-table-column>
      <el-table-column label="내용" prop="comment" :formatter="getEmptyText"></el-table-column>
      <el-table-column label="파일" width="60px" align="center" header-align="center">
        <template slot-scope="scope">
            <div v-if="scope.row.fileInfo != null" style="display:flex; justify-content:center;">
              <i class="far fa-file-download"></i>
            </div>
            <div style="display:flex; justify-content:center;" v-else>-</div>
          </template>
      </el-table-column>
      <el-table-column label="삭제" width="60px" align="center" header-align="center" v-if="isAdmin && !isReadOnlyTicket">
        <template slot-scope="scope">
            <span @click="deleteProcessHist(scope.row)">
              <i class="fal fa-times c-pointer"></i>
            </span>
          </template>
      </el-table-column>
    </el-table>
  </div>
  <!-- 연관 KEDB -->
  <div class="list-dot-tit mr-b25">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <strong class="list-tit" style="line-height:28px;padding-bottom:0px;"><span>연관 KEDB</span></strong>
      </div>
      <div class="vertical-center-box">
        <el-button v-if="isAdmin && !isReadOnlyTicket" type="primary" size="mini" @click="showAddRelationKedbPopup">추가</el-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="kedbLoading" ref="kedbTable" :data="relationKedbList" :columns="kedbColumns" :pagination="false" :show-custom-header="false" :show-search-tool="false" style="width:100%;" :column-default="columnDefault">
      <template slot-scope="scope" slot="kedb-title-slot">
         <span class="link c-pointer" @click="showKedbDetailView(scope.row)">{{scope.row.title}}</span>
       </template>
      <template slot-scope="scope" slot="delete-kedb-slot" >
         <span @click="deleteRelatedKedb(scope.row)">
           <i class="fal fa-times c-pointer"></i>
         </span>
       </template>
    </el-table-wrapper>
  </div>
  <w-event-status-hist-popup ref="histRefPop" :event-data="eventData"></w-event-status-hist-popup>
  <w-event-ticket-report-popup ref="reportRefPop" :trouble-ticket-group-id="troubleTicketGroupId" :eventList="eventList" @reload="loadTroubleShootingTicketInfo"></w-event-ticket-report-popup>
  <w-relation-kedb-add-popup ref="relationKedbAddPopup" @save-relation-kedb-info="saveRelationKedbInfo" />
  <w-kedb-detail-popup ref="detailPopup" viewType="relationKedbPopup" :params="kedbDetailParams" />
  <w-kedb-add-popup ref="kedbEditPopup" popupType="ADD" :kedb-detail-info="newKedbData" @reload="loadRelationKedbInfo" />
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { forEach, isNil, isEmpty, clone, cloneDeep, findIndex, remove, find } from 'lodash';
import unionWith from 'lodash/unionWith';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import TroubleShootingAPI from '@/api/event/trouble-shooting';
import msgUtil from '@/utils/message';
import { checkFileSize, isUnauthorizedFile } from '@/utils/file';
import { DUPLICATE_MESSAGE, MSG_UPLOAD_UNAUTHORIZED_FILE } from '@/constants/file';
import WEventlevelCell from '@/components/table/EventlevelCell';
import { columnDefault } from '@/constants/table';
import WEventTicketReportPopup from '@/views/event/components/popup/EventTicketReportPopup';
import WEventStatusHistPopup from '@/views/event/components/popup/EventStatusHistPopup';
import WKedbDetailPopup from '@/views/event/kedb/components/popup/KedbDetailPopup';
import WKedbAddPopup from '@/views/event/kedb/components/popup/KedbAddPopup';
import WRecommendHandlingTroubleButton from '@/views/event/components/RecommendHandlingTroubleButton';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';
import WRelationKedbAddPopup from './popup/RelationKedbAddPopup';

export default {
  name: 'WEventTicketStatus',
  components: {
    WEventlevelCell,
    WEventTicketReportPopup,
    WEventStatusHistPopup,
    WRelationKedbAddPopup,
    WKedbDetailPopup,
    WKedbAddPopup,
    WRecommendHandlingTroubleButton,
  },
  props: {
    /**
     * 장애티켓 상세 정보 조회 파라미터
     * 장애티켓 목록에서 조회된 경우 목록의 조건 파라미터를 가지며,
     * 그 외의 경우는 troubleTicketGroupId만 필드로 가진다.
     * { troubleTicketGroupId, tableParams }
     * @type {Object}
     */
    params: {
      type: Object,
    },
    /**
     * 장애티켓 상세 정보가 팝업으로 띄워지는 경우 상단의 컨트롤바를 보여주지 않는다.
     * @type {Object}
     */
    isPopupView: {
      type: Boolean,
    },
    /**
     * 장애티켓탭에서만 편집기능을 제공하는 플래그
     * @type {Object}
     */
    isReadOnlyTicket: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /* 공통 */
      troubleTicketGroupId: null,
      troubleShootingTableParams: null,
      columnDefault,
      kedbDetailParams: null,
      entireLoading: false, //  장애 티켓 전체 상세 정보 로딩용.
      /* 장애 티켓 정보 */
      troubleTicketInfo: {},
      /* 대상 이벤트 정보 */
      eventList: [],
      eventData: null,
      eventDataForRecommend: null,
      targetEventColumn: [
        {
          prop: 'eventlevelId',
          label: '등급',
          width: 80,
          scopedSlot: 'eventlevel-slot',
          className: 'eventlevel',
          columnKey: 'eventlevelId',
        },
        {
          prop: 'managetypeName',
          label: '관리구분',
          width: 80,
        },
        {
          prop: 'objName',
          label: '대상',
          scopedSlot: 'obj-name-slot',
          width: 150,
        },
        {
          prop: 'rsctypeName',
          label: '자원구분',
          width: 115,
        },
        {
          prop: 'eventMessage',
          label: '장애메시지',
          scopedSlot: 'event-message-slot',
        },
        {
          prop: 'checkDatetime',
          label: '최초발생시각',
          width: 155,
          formatter: this.getDateFormatter,
        },
        {
          prop: 'eventCount',
          label: '연관 이벤트(개)',
          width: 150,
          scopedSlot: 'event-count-slot',
        },
      ],
      /* 처리 이력 */
      troubleShootingHist: [],
      fileList: [],
      eventTicketStatusComment: '',
      histLoading: false, // 처리 이력 로딩용
      processHistColumn: [
        {
          prop: 'registDatetime',
          label: '작성일시',
          width: 155,
          formatter: this.getDateFormatter,
        },
        {
          prop: 'registerId',
          label: '작성자',
          width: 135,
        },
        {
          prop: 'comment',
          label: '내용',
          formatter: this.getEmptyText,
        },
        {
          prop: 'attachFileId',
          headerAlign: 'center',
          scopedSlot: 'file-down-slot',
          label: '파일',
          width: 60,
        },
      ],
      attachFileColumns: [
        {
          prop: 'name',
          label: '파일명',
          sortable: true,
        },
        {
          label: '삭제',
          width: '55',
          align: 'center',
          scopedSlot: 'delete-slot',
        },
      ],
      /* 연관 KEDB */
      relationKedbList: [],
      kedbLoading: false, // 연관 KDEDB 로딩용
      kedbTemplateColumns: [
        {
          prop: 'seqNumber',
          label: 'No',
          width: 55,
        },
        {
          prop: 'title',
          label: '제목',
          scopedSlot: 'kedb-title-slot',
        },
        {
          prop: 'writerId',
          label: '작성자',
          width: '130px',
        },
        {
          prop: 'writeDatetime',
          label: '작성일시',
          width: '130px',
          formatter: this.getDateFormatter,
        },
        {
          prop: 'recommendCount',
          label: '추천수',
          width: '70px',
          align: 'center',
          headerAlign: 'center',
        },
        {
          prop: 'viewCount',
          label: '조회수',
          width: '70px',
          formatter: this.getEmptyText,
          align: 'center',
          headerAlign: 'center',
        },
      ],
      histDeleteColumn: [{ label: '삭제', align: 'center', headerAlign: 'center', scopedSlot: 'delete-kedb-slot', width: 55 }],
      eventHistSeqNumbers: [],
      newKedbData: {},
      fileListFlag: false,
      preBtnFlag: false,
      nexBtnFlag: false,
      nextId: null,
      prevId: null,
    };
  },
  computed: {
    /**
     * 어드민 계정 여부
     * @author Ju
     * @return {Boolean} [description]
     */
    isAdmin() {
      return this.$store.getters.userInfo.managerType === 'ADMIN';
    },
    /**
     * 장애 티켓 처리 완료 여부
     * @author Ju
     * @return {Boolean} [description]
     */
    isCompletedTicket() {
      return !isEmpty(this.troubleTicketInfo) && (this.troubleTicketInfo.troubleStatus === 'S' || this.troubleTicketInfo.troubleStatus === 'F');
    },
    /**
     * 연관 kedb 컬럼
     * @author Ju
     * @return {[type]} [description]
     */
    kedbColumns() {
      return this.isAdmin && !(this.isReadOnlyTicket) ? unionWith(this.kedbTemplateColumns, this.histDeleteColumn) : this.kedbTemplateColumns;
    },
    /**
     * 이전 버튼 제공 여부
     * @author Ju
     * @return {Boolean}
     */
    showPrevBtn() {
      return !isEmpty(this.troubleTicketInfo) && !isNil(this.troubleTicketInfo.prevTicketId);
    },
    /**
     * 다음 버튼 제공 여부
     * @author Ju
     * @return {Boolean}
     */
    showNextBtn() {
      return !isEmpty(this.troubleTicketInfo) && !isNil(this.troubleTicketInfo.nextTicketId);
    },
    isAbleApplyTicketHist() {
      const comment = this.eventTicketStatusComment.replace(/ /gi, '');
      return !isEmpty(comment) || (this.fileList.length !== 0);
    },
    ...mapGetters(['urgencyData', 'impactData']),
  },
  watch: {
    params: {
      immediate: true,
      handler(value) {
        if (!isNil(value) && !isNil(value.troubleTicketGroupId) && value.troubleTicketGroupId > -1) {
          this.troubleShootingTableParams = !isEmpty(value.tableParams) ? value.tableParams : null;
          this.troubleTicketGroupId = value.troubleTicketGroupId;
        } else {
          this.troubleShootingTableParams = null;
          this.troubleTicketGroupId = null;
        }
      },
    },
    troubleTicketGroupId: {
      immediate: true,
      handler(value) {
        if (!isNil(value)) {
          this.$nextTick(() => {
            this.loadTroubleShootingTicketInfo();
          });
        }
      },
    },
    troubleTicketInfo: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.clearProcessHistInputComponent();
        });
      },
    },
    /**
     * 장애티켓 상세보기 > 대상 이벤트 정보가 담긴다.
     * @type {Object}
     */
    eventList: {
      immediate: false,
      handler(value) {
        if (!isEmpty(value)) {
          this.eventHistSeqNumbers = [];
          this.eventList.forEach((item) => {
            this.eventHistSeqNumbers.push(item.seqNumber);
          });
        }
      },
    },
  },
  methods: {
    /**
     * 장애 티켓 상세 정보를 조회한다.
     * @author Ju
     */
    loadTroubleShootingTicketInfo() {
      let params;
      if (isEmpty(this.troubleShootingTableParams)) {
        params = {
          troubleTicketGroupId: this.troubleTicketGroupId,
        };
      } else {
        params = {
          ...this.troubleShootingTableParams,
          troubleTicketGroupId: this.troubleTicketGroupId,
        };
      }
      // 장애티켓 상세 컴포넌트에 전달할 장애티켓 그룹 정보 조회
      this.entireLoading = true;
      TroubleShootingAPI.getTroubleShootingDetailInfo(params)
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.troubleTicketInfo = isEmpty(result.troubleShootingInfo) ? {} : result.troubleShootingInfo;
            this.eventList = isEmpty(result.eventList) ? [] : result.eventList;
            this.troubleShootingHist = isEmpty(result.troubleShootingHist) ? [] : result.troubleShootingHist;
            this.relationKedbList = isEmpty(result.relationKedbList) ? [] : result.relationKedbList;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장애 티켓 정보', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장애 티켓 정보', false));
          throw new Error(e);
        })
        .finally(() => {
          this.entireLoading = false;
        });
    },
    /**
     * 장애 티켓 처리 이력을 조회한다.
     */
    loadTroubleShootingHist() {
      this.histLoading = true;
      TroubleShootingAPI.getTroubleShootingHistInfo(this.troubleTicketGroupId)
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.troubleShootingHist = result;
            this.fileInfo = result.fileInfo;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장애 티켓 처리 이력', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장애 티켓 처리 이력', false));
          throw new Error(e);
        })
        .finally(() => {
          this.histLoading = false;
        });
    },
    /**
     * 장애 티켓 연관 KEDB 목록을 조회한다.
     * @author yelim
     */
    loadRelationKedbInfo() {
      this.kedbLoading = true;
      TroubleShootingAPI.getRelationKedbInTroubleTicket(this.troubleTicketGroupId)
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.relationKedbList = result;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '연관 KEDB', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '연관 KEDB', false));
          throw new Error(e);
        })
        .finally(() => {
          this.kedbLoading = false;
        });
    },
    /**
     * 이전 장애티켓 상세 정보를 조회한다.
     * @author Ju
     */
    clickPrevButton() {
      this.troubleTicketGroupId = this.troubleTicketInfo.prevTicketId;
    },
    /**
     * 다음 장애티켓 상세 정보를 조회한다.
     * @author Ju
     */
    clickNextButton() {
      this.troubleTicketGroupId = this.troubleTicketInfo.nextTicketId;
    },
    /**
     * 대상 이벤트의 상태 변경 이력 팝업을 연다.
     * @author Ju
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    showtTargetEventHistPopup(item) {
      this.eventData = clone(item);
      this.$refs.histRefPop.open();
    },
    /**
     * 이벤트 대상 선택 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onEventSelectionChange(row) {
      this.eventDataForRecommend = clone(row);
    },
    /**
     * 처리 이력을 등록한다.
     */
    addProcessHist() {
      // contentType 설정
      const data = new FormData();
      data.append('comment', this.eventTicketStatusComment);
      data.append('troubleTicketGroupId', this.troubleTicketInfo.troubleTicketGroupId);

      const objInfoList = [];
      forEach(this.eventList, (item) => {
        objInfoList.push(item.objId);
      });
      data.append('objInfoList', objInfoList);
      forEach(this.fileList, (value, index) => {
        data.append(`file${index}`, value);
      });

      const target = '처리 이력';
      const action = msgUtil.action.REGIST;
      TroubleShootingAPI.addTroubleShootingHist(data)
        .then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadTroubleShootingHist();
            this.clearProcessHistInputComponent();
          } else {
            this.$message(msgUtil.getCustomResultMsgData(response.data.message, false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        });
    },
    /**
     * 처리 이력 입력 컴포넌트를 초기화한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clearProcessHistInputComponent() {
      this.eventTicketStatusComment = ''; // 의견정보 초기화
      this.$refs.fileUpload.clearFiles(); // 파일 업로드 대상 삭제
      this.fileList = [];
      this.fileListFlag = false;
    },
    // 업로드 대상 파일을 선택하였을 시 이벤트
    changeUploadFile(item) {
      // 비인가 확장자 파일인 경우 업로드 불가능
      if (isUnauthorizedFile(item)) {
        this.$message(msgUtil.getCustomResultMsgData(MSG_UPLOAD_UNAUTHORIZED_FILE, false));
        return;
      }
      const ableFileSizeInfo = checkFileSize(item.raw.size);
      const fileName = item.raw.name;
      if (findIndex(this.fileList, ['name', fileName]) > -1) {
        this.$message(msgUtil.getCustomMsgData(DUPLICATE_MESSAGE));
        return;
      }
      if (!ableFileSizeInfo.enable) {
        this.$message(msgUtil.getCustomMsgData(ableFileSizeInfo.message));
      } else {
        this.fileList.push(item.raw);
      }
      this.fileListFlag = true;
    },
    /**
     * 첨부파일 목록에서 첨부파일을 삭제한다. 저장 버튼을 누르지 않으면 서버로 요청을 보내지 않는다.
     * @author yelim
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    deleteAttachFileInfo(row) {
      const originFileData = cloneDeep(this.fileList);
      remove(originFileData, (item) => {
        if (item.name === row.name) {
          return true;
        }
        return false;
      });
      this.fileList = originFileData;
    },
    /**
     * 처리 이력을 삭제한다.
     * @param  {[type]} item [description]
     */
    deleteProcessHist(item) {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        const params = {
          seqNumber: item.seqNumber,
          troubleTicketGroupId: this.troubleTicketGroupId,
          attachFileId: item.attachFileId,
        };
        TroubleShootingAPI.deleteTroubleShootingHist(params)
          .then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '처리이력', true));
              this.loadTroubleShootingHist();
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '처리이력', false));
            }
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '처리이력', false));
            throw new Error(e);
          });
      });
    },
    /**
     * 장애티켓 상세에서 장애티켓 목록으로 전환하는 경우 데이터를 초기화한다.
     * @author yelim
     */
    showTroubleTicketList() {
      this.$emit('show-trouble-ticket-list');
    },
    /**
     * 장애티켓 상세 화면에서 버튼으로 이전/다음 장애티켓에 대한 상세 조회가 가능하다.
     * @author yelim
     */
    clickForChangeTargetGroup(type) {
      if (type === 'pre') {
        this.troubleTicketGroupId = this.prevId;
      } else {
        this.troubleTicketGroupId = this.nextId;
      }
    },
    /**
     * 장애 티켓 처리 완료 보고 팝업을 연다.
     */
    showTroubleTicketCompleteReportPopup() {
      this.$refs.reportRefPop.open();
    },
    /**
     * 첨부 파일을 다운로드한다.
     * @author yelim
     */
    downloadAttachFile(item) {
      const params = {
        attachFilename: item.attachFilename,
        troubleTicketGroupId: item.troubleTicketGroupId,
        seqNumber: item.seqNumber,
      };
      TroubleShootingAPI.downloadAttachFile(params);
    },
    /**
     * 연관 KEDB 추가 팝업을 연다.
     * @author yelim
     * @return {[type]} [description]
     */
    showAddRelationKedbPopup() {
      this.$refs.relationKedbAddPopup.open();
    },
    /**
     * 장애티켓에 KEDB를 연결시킨다.
     * @author yelim
     */
    saveRelationKedbInfo(relationKedbs) {
      const params = [];
      if (relationKedbs.length > 0) {
        // 현재 목록에서 중복되지 않는 항목만 추가한다.
        relationKedbs.forEach((item) => {
          if (!find(this.relationKedbList, { seqNumber: item.seqNumber })) {
            params.push({
              troubleTicketGroupId: this.troubleTicketGroupId,
              seqNumber: item.seqNumber,
            });
          }
        });
        if (params.length > 0) {
          TroubleShootingAPI.setRelationKedbInTroubleTicket(params)
            .then((response) => {
              if (response.data.success) {
                this.$refs.relationKedbAddPopup.close();
                this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '연관 KEDB', true));
                this.loadRelationKedbInfo();
              } else {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '연관 KEDB', false));
              }
            })
            .catch((e) => {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '연관 KEDB', false));
              throw new Error(e);
            });
        } else {
          this.$refs.relationKedbAddPopup.close();
          this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '연관 KEDB', true));
        }
      } else {
        this.$message(msgUtil.getCustomMsgData('장애티켓 항목을 선택해주십시오.'));
      }
    },
    /**
     * Kedb 상세 팝업을 연다
     * @author yelim
     */
    showKedbDetailView(row) {
      this.kedbDetailParams = {
        seqNumber: row.seqNumber,
      };
      this.$refs.detailPopup.open();
    },
    /**
     * 추가된 연관 KEDB 목록에서 장애티켓에 연결된 kedb를 삭제한다.
     * @author yelim
     */
    deleteRelatedKedb(row) {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        const params = {
          seqNumber: row.seqNumber,
          troubleTicketGroupId: this.troubleTicketGroupId,
        };
        TroubleShootingAPI.deleteRelationKedbInTroubleTicket(params)
          .then((response) => {
            if (response.data.success) {
              this.loadRelationKedbInfo();
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '연관 KEDB', true));
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '연관 KEDB', false));
            }
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '연관 KEDB', false));
            throw new Error(e);
          });
      });
    },
    /**
     * 장애 티켓 정보로 KEDB를 추가한다.
     * @author yelim
     */
    addKedbByTicket() {
      this.newKedbData = {
        kedbAttachInfo: [],
        kedbInfo: {
          title: this.troubleTicketInfo.subject,
          errorSymptomRaw: this.troubleTicketInfo.troubleSymptom,
          errorSolutionRaw: `${this.troubleTicketInfo.troubleReason}<br/>${this.troubleTicketInfo.troubleTreatment}`,
        },
        kedbRscInfo: [],
        kedbTroubleTicketInfo: [
          {
            troubleTicketGroupId: this.troubleTicketGroupId,
            subject: this.troubleTicketInfo.subject,
          },
        ],
      };
      this.$refs.kedbEditPopup.open();
    },
    /**
     * 날찌를 문자열 포맷으로 변환한다.
     * @author yelim
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    /**
     * 공백 여부를 체크하고 공백일 경우에는 '-', 아닐 경우 원래 값을 반환한다.
     * @author yelim
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getEmptyText(row, column, value) {
      if (!isNil(value) && value !== '') {
        return value;
      }
      return EMPTY_TEXT;
    },
    /**
     * 장비명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
  },
};
</script>
<style scoped>
.title-table {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/event/components/EventTicketStatus.vue